import moment from 'moment';

import templateUrl from './time-entry-modification-audit-log.component.html'
import { AuditLogHistoryEntryModal } from './audit-log-entry-history-modal.component';

export const TimeEntryModificationAuditLogComponent = {
    controller: TimeEntryModificationAuditLogController,
    controllerAs: "vm",
    templateUrl
};

function TimeEntryModificationAuditLogController($uibModal, $q, auditLogService, utilityService,apexApiUrl) {
    'ngInject';
    const vm = this;
    vm.auditLogs;
    vm.selectedAuditLog;
    vm.employeeLimit = 25;
    vm.pageSize = 25;
    vm.pageNumber = 1;

    vm.onSelectAuditLog = onSelectAuditLog;
    vm.onInitAuditLog = onInitAuditLog;
    vm.onViewHistory = onViewHistory;
    vm.exportAuditLogs = exportAuditLogs;

    vm.pageSize = 10;
    vm.pageNumber = 1;
    vm.onChangePage = onChangePage;
    vm.onChangeSearchText = onChangeSearchText;
    loadPageData();
    vm.searchText = "";
    return;

    //////////

    function loadPageData() {
        utilityService.showLoading();
        retrieveTimeEntryModificationsAuditLogs()
            .then(function (auditLogs) {
                vm.auditLogs = auditLogs.Entities;
                vm.auditLogs.forEach(hydrateAuditLog);
                vm.totalEntries = auditLogs.TotalEntityCount;
            })
            .catch(function (ex) {
                console.error(ex);
            })
            .then(utilityService.hideLoading);
    }

    function hydrateAuditLog(log) {
        log.Count = log.EntriesCount;
    }

    function onSelectAuditLog(auditLog) {
        vm.selectedAuditLog = auditLog;
    }

    function onInitAuditLog(auditLog) {
        loadAuditLogEntries(auditLog)
            .catch(function (ex) {
                console.error(ex);
            });
    }

    function retrieveTimeEntryModificationsAuditLogs() {
        return auditLogService.retrieveTimeEntryModificationsAuditLogsPage(vm.pageNumber - 1, {
            PageSize: vm.pageSize,
            CorporationName: vm.searchText
        })
    }

    function onViewHistory(timeEntry) {
        // Open a modal to display the time entry history.
        $uibModal.open({
            ...AuditLogHistoryEntryModal,
            resolve: {
                auditLogEntry: () => timeEntry,
                title: () => "Changes to Time Entry"
            }
        })
    }

    function loadAuditLogEntries(auditLog) {
        if (auditLog.Modifications) {
            return $q.when(auditLog);
        }
        return auditLogService.retrieveTimeEntryModificationsAuditLog(auditLog.Employee.Id)
            .then(function (auditLogEntries) {
                if (auditLogEntries === null) {
                    auditLog.Modifications = [];
                } else {
                    auditLog.Modifications = auditLogEntries.Modifications.map(p => ({
                        ...p,
                        History: p.History.map(q => ({
                            ...q,
                            OldValueData: q.__moment ? formatTimeChange(q.__moment.OldValueData) : q.OldValueData,
                            NewValueData: q.__moment ? formatTimeChange(q.__moment.NewValueData) : q.NewValueData
                        }))
                    }));
                }
                return auditLog;
            });
    }

    function onChangePage(pageNumber) {
        vm.selectedAuditLog = null;
        vm.pageNumber = pageNumber;
        loadPageData();
    }

    function onChangeSearchText(text) {
        vm.selectedAuditLog = null;
        vm.searchText = text;
        loadPageData();
    }

    function exportAuditLogs() {
        window.location.href = `${apexApiUrl}/audit-logs/time-entry-modification/`
            + `${vm.selectedAuditLog.IcdCorporation.IcdCorporationID}.csv`;
    }

    function formatTimeChange(momentTime) {
        return moment.parseZone(momentTime)
            .format("hh:mm a Z")
    }
}
